<template>
    <div>
        <div v-if="status == 0">
            Mengambil data barang, mohon menunggu...
        </div>
        <div v-else-if="status == -1">
            Gagal mengambil data barang.
        </div>
        <div v-else-if="status == 1">
            <h3 id="item-type" class="mb-0">{{ data.type }} <span v-if="data.item_year != null">({{ data.item_year }})</span></h3>
            <span id="item-kind">{{ data.kind }}</span> - <span id="item-brand">{{ data.brand }}</span>

            <template v-if="!isLmScan">
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>No. Faktur</strong><br />
                        <span id="no-faktur">{{ data.no_faktur_pgi }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Kadar</strong><br />
                        <span id="purity">{{ data.purity }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Berat Kotor</strong><br />
                        <span id="dry-weight">{{ data.dry_weight }}gr</span>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>Berat Potongan</strong><br />
                        <span id="weight-reduction">{{ data.weight_reduction }}gr</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Berat Bersih</strong> <br />
                        <span>{{ netWeight }} gr</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Gudang</strong><br />
                        <span>{{ data.warehouse_name || "-" }}</span>
                    </b-col>
                </b-row>
            </template>
            <template v-else>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>No. Faktur</strong><br />
                        <span id="no-faktur">{{ data.no_faktur_pgi }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Berat Kotor</strong><br />
                        <span id="dry-weight">{{ data.dry_weight }}gr</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Gudang</strong><br />
                        <span>{{ data.warehouse_name || "-" }}</span>
                    </b-col>
                </b-row>
            </template>

            <b-row class="mt-4">
                <b-col md="12" class="text-right">
                    <b-button id="confirm-add-button" variant="primary" @click="confirmAdd" :disabled="isSubmitting">
                        <i class="fa fa-check mr-2" />Tambahkan
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <b-modal id="m-confirm-add" title="Konfirmasi" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div>Konfirmasi penambahan barang ini ke batch.</div>
            <b-row class="mt-4">
                <b-col md="6">
                    <strong>No. Faktur</strong><br />
                    <span>{{ data.no_faktur_pgi }}</span>
                </b-col>
                <b-col md="6">
                    <strong>Barang</strong><br />
                    <span>{{ data.type }} <span v-if="data.item_year != null">({{ data.item_year }})</span></span>
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="!isLmScan">
                <b-col md="6">
                    <strong>Kadar</strong><br />
                    <span>{{ data.purity }}</span>
                </b-col>
                <b-col md="6">
                    <strong>Berat Bersih</strong><br />
                    <span>{{ netWeight }} gr</span>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execAddItem">
                    {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        batchId: { type: Number, required: true },
        noFaktur: { type: String, required: true },
        type: { type: Number, required: true }
    },
    data() {
        return {
            status: 0,
            isSubmitting: false,
            data: {}
        };
    },
    computed: {
        isLmScan() {
            return this.data.kind_id === 251;
        },
        netWeight() {
            let dw = parseFloat(this.data.dry_weight || 0);
            let wr = parseFloat(this.data.weight_reduction || 0);
            return (dw - wr).toFixed(3);
        }
    },
    methods: {
        init() {
            this.status = 0;
            this.data = {};
            this.getInventory();
        },

        getInventory() {
            this.$axios
                .get(`gold-batches/get-item?type=${this.type}&no_faktur_pgi=` + this.noFaktur)
                .then(res => {
                    this.data = res.data.data;
                    if (this.data.is_already_in_draft_batch) {
                        this.$bvToast.toast("Barang sudah ada di batch lain", {
                            title: "Gagal",
                            variant: "danger",
                            solid: true,
                            autoHideDelay: 5000
                        });
                        this.status = -1;
                    } else {
                        this.status = 1;
                    }
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.status = -1;
                });
        },

        confirmAdd() {
            this.$bvModal.show("m-confirm-add");
        },

        execAddItem() {
            this.isSubmitting = true;
            let payload = {
                inventory_id: this.data.id
            };
            this.$axios
                .post("gold-batches/" + this.batchId + "/items", payload)
                .then(() => {
                    this.$bvModal.hide("m-confirm-add");
                    this.$emit("item-added", "Barang berhasil ditambahkan!");
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    },

    created() {
        if (this.noFaktur) {
            this.init();
        }
    }
};
</script>
